/* Noble Woodcraft — minimal theme JS (vanilla, no dependencies) */
(function () {
  'use strict';

  /* ---------- Sticky header shadow ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Product card carousels: sync dot indicators ---------- */
  document.querySelectorAll('[data-pc-carousel]').forEach(function (track) {
    var dots = track.parentElement.querySelectorAll('.pc-carousel__dot');
    if (dots.length < 2) return;
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = track.clientWidth || 1;
        var i = Math.round(Math.abs(track.scrollLeft) / w);
        if (i > dots.length - 1) i = dots.length - 1;
        for (var n = 0; n < dots.length; n++) dots[n].classList.toggle('is-active', n === i);
      });
    }, { passive: true });
  });

  /* ---------- Generic open/close helper ---------- */
  function trapToggle(el, cls, open) {
    if (!el) return;
    el.classList.toggle(cls, open);
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  /* ---------- Mobile navigation ---------- */
  var mobileNav = document.getElementById('MobileNav');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-open]')) { trapToggle(mobileNav, 'is-open', true); }
    if (e.target.closest('[data-nav-close]') || e.target.classList.contains('mobile-nav__overlay')) {
      trapToggle(mobileNav, 'is-open', false);
    }
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');

  function openCart() { trapToggle(drawer, 'is-open', true); }
  function closeCart() { trapToggle(drawer, 'is-open', false); }

  function localeRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function refreshDrawer() {
    /* locale-aware so the drawer renders in the active language */
    return fetch(localeRoot() + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var body = drawer && drawer.querySelector('[data-cart-body]');
        if (body && data['cart-drawer']) body.innerHTML = data['cart-drawer'];
      });
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  /* Add to cart (intercept product forms) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }

    var root = localeRoot();
    var addons = form.querySelectorAll('input[name="addon_ids[]"]:checked');
    var engInput = form.querySelector('[data-engraving-input]');
    var engText = engInput ? engInput.value.trim() : '';
    var request;

    if (addons.length || engText) {
      /* Add the main product (with any engraving message) plus add-ons / engraving fee in one request */
      var idEl = form.querySelector('[name="id"]');
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = Number(qtyEl && qtyEl.value) || 1;
      var mainItem = { id: Number(idEl.value), quantity: qty };
      if (engText) {
        var key = engInput.getAttribute('data-engraving-key') || 'Engraving Message';
        mainItem.properties = {};
        mainItem.properties[key] = engText;
      }
      var items = [mainItem];
      Array.prototype.forEach.call(addons, function (a) {
        items.push({ id: Number(a.value), quantity: 1 });
      });
      if (engText) {
        var feeId = Number(engInput.getAttribute('data-engraving-fee-id'));
        if (feeId) items.push({ id: feeId, quantity: qty, properties: { _engraving: '1' } });
      }
      request = fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
    } else {
      request = fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
    }

    request
      .then(function (r) { return r.json(); })
      .then(function () { return fetch(localeRoot() + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) { updateCount(cart.item_count); return refreshDrawer(); })
      .then(function () { openCart(); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
  });

  /* Discount code: apply via Shopify's /discount/<code> route, then land on the cart page */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name="discount"]');
    var code = input && input.value ? input.value.trim() : '';
    if (!code) { if (input) input.focus(); return; }
    var b = form.querySelector('button[type="submit"]');
    if (b) { b.classList.add('is-loading'); b.disabled = true; }
    var root = localeRoot();
    window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart');
  });

  /* Drawer interactions: open / close / qty / remove */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]') || e.target.classList.contains('cart-drawer__overlay')) closeCart();

    var line = e.target.closest('.cart-line');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var valEl = line.querySelector('[data-qty-val]');
    var qty = valEl ? parseInt(valEl.textContent, 10) : 1;

    if (e.target.closest('[data-qty-up]')) changeQty(key, qty + 1);
    else if (e.target.closest('[data-qty-down]')) changeQty(key, qty - 1);
    else if (e.target.closest('[data-line-remove]')) changeQty(key, 0);
  });

  function changeQty(key, quantity) {
    var body = drawer.querySelector('[data-cart-body]');
    if (body) body.classList.add('is-loading');
    fetch(localeRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return refreshDrawer(); })
      .then(function () { if (body) body.classList.remove('is-loading'); });
  }

  /* Close drawers on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); trapToggle(mobileNav, 'is-open', false); }
  });
})();
